
      import WaitDeliver from './wait-deliver.vue'
      import type { App, Plugin } from 'vue'

      export const WaitDeliverPlugin: Plugin = {
        install(app: App) {
          app.component('WaitDeliver', WaitDeliver)
        },
      }
      export { WaitDeliver }
      